export const NEW_PATIENT = 1;
export const EXISTING_PATIENT = 2;

export const NEW_CONSULT_TYPE = 67422;
export const REPEAT_CONSULT_TYPE = 65578;
export const NEW_CHECKIN_TYPE = 17;
export const REPEAT_CHECKIN_TYPE = 16;
